import { c as _c } from "react/compiler-runtime";
import { NoResult } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/auto-complete-input/no-search-result";
import { useQueryCities } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/auto-complete-input/queries";
import { CityType, OnChangeItemType } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/auto-complete-input/types";
import { useDebounce } from "@website/hooks/debounce";
import { Origin } from "@website/icons/components/origin";
import { useState } from "react";
const useAutoComplete = (type, defaultValue, onChangeItem, suggestions) => {
  const $ = _c(22);
  const [query, setQuery] = useState("");
  const [selectedItem, setSelectedtem] = useState(null);
  const debouncedQuery = useDebounce(query, 250);
  const {
    data: cities,
    isLoading: isLoadingCities
  } = useQueryCities(debouncedQuery);
  let t0;
  if ($[0] !== cities || $[1] !== debouncedQuery.length || $[2] !== suggestions) {
    t0 = debouncedQuery.length >= 2 ? cities || [] : suggestions || [];
    $[0] = cities;
    $[1] = debouncedQuery.length;
    $[2] = suggestions;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const list = t0;
  let t1;
  if ($[4] !== list) {
    t1 = Array.isArray(list) ? list?.map(_temp) : [];
    $[4] = list;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const listNormalized = t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = value => {
      setQuery(value);
    };
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const onChangeQuery = t2;
  let t3;
  if ($[7] !== list || $[8] !== onChangeItem) {
    t3 = id => {
      const originItem = list?.find(origin => `${origin?.iata_code}` === `${id}`);
      setQuery("");
      setSelectedtem(originItem);
      onChangeItem(originItem);
    };
    $[7] = list;
    $[8] = onChangeItem;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const onSelectItem = t3;
  const noResult = query?.length >= 2 && !isLoadingCities && list && list?.length === 0;
  const t4 = selectedItem?.title_fa || defaultValue || "";
  let t5;
  if ($[10] !== noResult || $[11] !== query) {
    t5 = noResult ? <NoResult query={query} /> : undefined;
    $[10] = noResult;
    $[11] = query;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== isLoadingCities || $[14] !== list || $[15] !== listNormalized || $[16] !== onSelectItem || $[17] !== query || $[18] !== selectedItem || $[19] !== t4 || $[20] !== t5) {
    t6 = {
      list,
      loading: isLoadingCities,
      listNormalized,
      onSelect: onSelectItem,
      onChangeQuery,
      selectedItem,
      selectedText: t4,
      query,
      NoResult: t5
    };
    $[13] = isLoadingCities;
    $[14] = list;
    $[15] = listNormalized;
    $[16] = onSelectItem;
    $[17] = query;
    $[18] = selectedItem;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
};
export const useOrigin = (defaultValue, onChangeItem, originSuggestions) => {
  const $ = _c(10);
  const result = useAutoComplete("origin", defaultValue, onChangeItem, originSuggestions);
  let t0;
  if ($[0] !== result.NoResult || $[1] !== result.list || $[2] !== result.listNormalized || $[3] !== result.loading || $[4] !== result.onChangeQuery || $[5] !== result.onSelect || $[6] !== result.query || $[7] !== result.selectedItem || $[8] !== result.selectedText) {
    t0 = {
      originList: result.list,
      originLoading: result.loading,
      originListNormalized: result.listNormalized,
      onSelectOrigin: result.onSelect,
      onChangeOriginQuery: result.onChangeQuery,
      selectedOriginItem: result.selectedItem,
      selectedOriginText: result.selectedText,
      originQuery: result.query,
      OriginNoResult: result.NoResult,
      originLabel: "\u0645\u0628\u062F\u0627"
    };
    $[0] = result.NoResult;
    $[1] = result.list;
    $[2] = result.listNormalized;
    $[3] = result.loading;
    $[4] = result.onChangeQuery;
    $[5] = result.onSelect;
    $[6] = result.query;
    $[7] = result.selectedItem;
    $[8] = result.selectedText;
    $[9] = t0;
  } else {
    t0 = $[9];
  }
  return t0;
};
export const useDestination = (defaultValue, onChangeItem, destinationSuggestions) => {
  const $ = _c(10);
  const result = useAutoComplete("dest", defaultValue, onChangeItem, destinationSuggestions);
  let t0;
  if ($[0] !== result.NoResult || $[1] !== result.list || $[2] !== result.listNormalized || $[3] !== result.loading || $[4] !== result.onChangeQuery || $[5] !== result.onSelect || $[6] !== result.query || $[7] !== result.selectedItem || $[8] !== result.selectedText) {
    t0 = {
      destinationList: result.list,
      destinationLoading: result.loading,
      destinationListNormalized: result.listNormalized,
      onSelectDestination: result.onSelect,
      onChangeDestinationQuery: result.onChangeQuery,
      selectedDestinationItem: result.selectedItem,
      selectedDestinationText: result.selectedText,
      destinationQuery: result.query,
      DestinationNoResult: result.NoResult,
      destinationLabel: "\u0645\u0642\u0635\u062F"
    };
    $[0] = result.NoResult;
    $[1] = result.list;
    $[2] = result.listNormalized;
    $[3] = result.loading;
    $[4] = result.onChangeQuery;
    $[5] = result.onSelect;
    $[6] = result.query;
    $[7] = result.selectedItem;
    $[8] = result.selectedText;
    $[9] = t0;
  } else {
    t0 = $[9];
  }
  return t0;
};
function _temp(item) {
  return {
    id: item?.iata_code,
    title: item?.title_fa,
    subtitle: item?.iata_code,
    StartIcon: <Origin />
  };
}